function getPricePerCheck(price: number, checks: string) {
  return Number((price / Number(checks)).toFixed(2));
}

function getTotalDiscount(discount: number, oldDiscount: number) {
  const totalDiscount = 1 - (1 - oldDiscount / 100) * (1 - discount / 100);
  return Number((totalDiscount * 100).toFixed(1));
}

function getPrice(
  cost: string,
  value: string,
  oldCost: string,
  discount: number,
) {
  const discountForOldPrice = Number(oldCost)
    ? Number((100 - (Number(cost) / Number(oldCost)) * 100).toFixed(0))
    : 0;

  const price = discount
    ? Number((Number(cost) * (1 - discount / 100)).toFixed(2))
    : Number(cost);

  const pricePerCheck = getPricePerCheck(price, value);

  const oldPrice = discountForOldPrice ? Number(oldCost) : Number(cost);

  const totalDiscount = getTotalDiscount(discount, discountForOldPrice);

  return { price, pricePerCheck, oldPrice, discount: totalDiscount };
}

export default getPrice;
